<script lang="ts">
    import { searchMessage } from "../../utils/Constant/Constant";
    import { searchIcon } from "../../store";
    let setSearchicons:boolean;
    export let search:boolean;
    searchIcon.subscribe((value) => {
      setSearchicons = value;
    });
</script>
  
<div class={`${ search ? `Typeahead-menu ${setSearchicons ? "is-open" : ""}` : `Typeahead-menu` } `}>
    <div class="tt-dataset tt-dataset-0">
      <div class="EmptyMessage">
        {searchMessage}
      </div>
    </div>
</div>
  